import { render, staticRenderFns } from "./CompletionPercent.vue?vue&type=template&id=6b3e4864&"
import script from "./CompletionPercent.vue?vue&type=script&lang=js&"
export * from "./CompletionPercent.vue?vue&type=script&lang=js&"
import style0 from "./CompletionPercent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports